import "./App.css";
import React from "react";
import HomePage from "./pages/HomePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuctionPage from "./pages/AuctionPage";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import LoginUaePassPage from "./pages/LoginUaePassPage";
import LoginUaePassPageOTP from "./pages/LoginUaePassPageOTP";
import RegisterPage from "./pages/RegisterPage";
import AuctionDetailsPage from "./pages/AuctionDetailsPage";
import HorseProfile from "./pages/HorseProfile";
import BiddingPage from "./pages/BiddingPage";
import StudBookPage from "./pages/StudBookPage";
import OwnerProfile from "./pages/OwnerProfile";
import OwnerDetailsPage from "./pages/OwnerDetailsPage";
import HorseDetailsPage from "./pages/HorseDetailsPage";
import HorseMarket from "./pages/HorseMarket";
import HorseMarketProfile from "./pages/HorseMarketProfile";
import ForgetPasswordPage from "./pages/ForgetPasswordPage";
import SingleServicePage from "./pages/SingleServicePage";
import SinglePost from "./pages/SinglePost";
import AboutUs from "./pages/AboutUs";
import NewsPage from "./pages/NewsPage";
import HorseSupplies from "./pages/HorseSupplies";
import SingleSupplier from "./pages/SingleSupplier";
import SingleTransportCompany from "./pages/SingleTransportCompany";
import HorseTransportCompanies from "./pages/HorseTransportCompanies";
import EquestrianCentersClubs from "./pages/EquestrianCentersClubs";
import SingleEquestrianCentersClubs from "./pages/SingleEquestrianCentersClubs";
import ContactUs from "./pages/ContactUs";
import ServicesPage from "./pages/ServicesPage";
import OrgChartPage from "./pages/OrgChartPage";
import Shows from "./pages/Shows";
import ShowDetails from "./pages/ShowDetails";
import WahoConference from "./pages/WahoConference";
import ShowEntryCard from "./pages/ShowEntryCard";
import ScrollToTop from "./components/scroll-to-top";
import CalendarPage from "./pages/CalendarPage";
import ShowEntryDetails from "./pages/ShowEntryDetails";
import AddRegisterHorse from "./pages/AddRegisterHorse";
import ShowEntryConflict from "./pages/ShowEntryConflict";
import ShowEntryTotalRegisteredHorses from "./pages/ShowEntryTotalRegisteredHorses";
import ShowEntryParticipantsRequest from "./pages/ShowEntryParticipantsRequest";
import ShowEntrySubmissionSuccessful from "./pages/ShowEntrySubmissionSuccessful";
import GalleryPage from "./pages/GalleryPage";
import AlbumPage from "./pages/AlbumPage";
import WahoTrophy from "./pages/WahoTrophy";
import BookTable from "./pages/BookTable";
import ShowsCategories from "./pages/ShowsCategories";
import AuctionEntryCard from "./pages/AuctionEntryCard";
import Auctionentrytotalregisteredhorses from "./pages/AuctionEntryTotalRegisteredHorses";
import AuctionEntrySubmissionSuccessful from "./pages/AuctionEntrySubmissionSuccessful";
import BookingSubmissionSuccessful from "./pages/BookingSubmissionSuccessful";
import OpendBooking from "./pages/OpendBooking";
import RequestHorseOwnershipTransferSeller from "./pages/RequestHorseOwnershipTransferSeller";
import ServicesRequestsPaymentSuccessful from "./pages/ServicesRequestsPaymentSuccessful";
import ComingSoon from "./components/ComingSoon";
import SingleHospital from "./pages/SingleHospital";
import HorseHospitals from "./pages/HorseHospitals";
import CoursesPage from "./pages/CoursesPage";
import SponsersPage from "./pages/SponsersPage";
import SingleTermsAndConditionsShowPage from "./pages/SingleTermsAndConditionsShowPage";
import EducationalPage from "./pages/EducationalPage";
import AddOrganizerRequest from "./pages/AddOrganizerRequest";
import LiveStream from "./pages/LiveStream";
import RequestCoveringCertificate from "./pages/RequestCoveringCertificate";
import AwardPage from "./pages/AwardPage";
import { toast, ToastContainer } from "react-toastify";
import ShowCatalog from "./pages/ShowCatalog";
import RequestEmbryoOocyteTransferPermit from "./pages/RequestEmbryoOocyteTransferPermit";
import LiveBiddingScreen from "./pages/LiveBiddingScreen";
import HybridBiddingPage from "./pages/HybridBiddingPage";
import RequestEmbryoTransferRightPurchaceAgreement from "./pages/RequestEmbryoTransferRightPurchaceAgreement";
import RequestRegisteringNewArabianHorseFoal from "./pages/RequestRegisteringNewArabianHorseFoal";
import RequestForOwnedEAHSRegisteredHorsesCertificate from "./pages/RequestForOwnedEAHSRegisteredHorsesCertificate";
import RequestForRegistrationOfAnArabianHorseStud from "./pages/RequestForRegistrationOfAnArabianHorseStud";
import RequestToUpdateArabianHorseData from "./pages/RequestToUpdateArabianHorseData";
import PressCoverageRequest from "./pages/PressCoverageRequest";
import RequestToDeclarationOfArabianHorseDeath from "./pages/RequestToDeclarationOfArabianHorseDeath";
import InactiveHorseRegistrationRequest from "./pages/InactiveHorseRegistrationRequest";
import RequestToAddARacingNameForAnImportedArabianHorse from "./pages/RequestToAddARacingNameForAnImportedArabianHorse";
import ReqestForIssuingAnArabianHorsePassportDuplicateDamaged from "./pages/ReqestForIssuingAnArabianHorsePassportDuplicateDamaged";
import ImportHorseFrozenSemen from "./pages/ImportHorseFrozenSemen";
import OpenApp from "./pages/OpenApp";
import AddFoalHorse from "./pages/AddFoalHorse";
import ImportHorse from "./pages/ImportHorse";
import GeneticDisorderTesting from "./pages/GeneticDisorderTesting";
import JudgesPage from "./pages/JudgesPage";
import RequestSemenCertificate from "./pages/RequestSemenCertificate";
import ExportHorse from "./pages/ExportHorse";
import ShowParticipatePage from "./pages/showEntry/ShowParticipatePage";
import AddInternationalHorse from "./pages/showEntry/AddInternationalHorse";
import ShowEntryCheckoutPage from "./pages/showEntry/ShowEntryCheckoutPage";
import CoursesNewPage from "./pages/CoursesNewPage";
import CourseEnrollment from "./pages/CourseEnrollment";
import AuctionDetails from "./pages/auctionDetails/AuctionDetails";
import PresidentWord from "./pages/PresidentWord";
import CancelExportHorse from "./pages/CancelExportHorse";
import ExportHorseSemen from "./pages/ExportHorseSemen";
import LibraryPage from "./pages/EahsLibrary/LibraryPage.js";
import RoutesName from './RoutesName.js'
import { useLocation } from "react-router-dom/dist/index.js";
import AucitonEntryParticipate from "./pages/AuctionEntry/AuctionEntryParticipate/AucitonEntryParticipate.js";
import AuctionEntryCheckoutPage from "./pages/AuctionEntry/AuctionEntryCheckoutPage.js";
import CourseEnrollmentDate from "./pages/CourseEnrollmentDate.js";
import ChulibPage from "./pages/CholibShow/ChulibPage.js";
import PrivateRoute from "./PrivateRoute.js";
import OwnerServicesForm from "./pages/ownersServices/OwnerServicesForm.js";
import FontCompetitionPage from "./pages/fontCompetition/FontCompetitionPage.js";
import SemenMarketListPage from "./pages/seminMarket/Pages/SemenMarketListPage.js";
import SemenDetails from "./pages/seminMarket/Pages/SemenDetails.js";
import SemenCheckout from "./pages/seminMarket/Pages/SemenCheckout.js";
import DigitalCatalog from "./pages/DigitalCatalog.js";
import CompleteProfileMiddleWare from "./CompleteProfileMiddleWare.js";
function App() {
  const dismissAll = () => toast?.dismiss();
  const ShowsCategoriesID = process.env.REACT_APP_SHOWS_CATEFORIES_ID;
  const NoneEcahoShowsCategoriesID = process.env.REACT_APP_NONE_ECAHO_SHOWS_CATEFORIES_ID;

  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.has("eahsLang")
    ? searchParams.get("eahsLang")
    : searchParams.has("eahslang") ? searchParams.get("eahslang") : null;
  const currentLang = localStorage.getItem('eahsLang') ?? 'en';
  if (!!lang) {
    if (currentLang != lang) {
      localStorage.setItem('eahsLang', lang);
      window.location.reload();
    }
  }

  return (
    <Router>
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      <Layout>
        <Routes>


          <Route path={RoutesName.HOME} element={<CompleteProfileMiddleWare><HomePage key={'HomePage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.STUDBOOK} element={<CompleteProfileMiddleWare><StudBookPage key={'StudBookPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.AUCTIONS} element={<CompleteProfileMiddleWare><AuctionPage key={'AuctionPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SINGLE_AUCTION} element={<CompleteProfileMiddleWare><AuctionDetailsPage key={'AuctionDetailsPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.AUCTION} element={<CompleteProfileMiddleWare><AuctionDetails key={'AuctionDetails'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.OWNER_DETAILS} element={<CompleteProfileMiddleWare><OwnerDetailsPage key={'OwnerDetailsPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.HORSE_DETAILS} element={<CompleteProfileMiddleWare><HorseDetailsPage key={'HorseDetailsPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.HORSE_MARKET_PROFILE} element={<CompleteProfileMiddleWare><HorseMarketProfile key={'HorseMarketProfile'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.LOGIN} element={<CompleteProfileMiddleWare><LoginPage key={'LoginPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.LOGIN_UAE_PASS} element={<CompleteProfileMiddleWare><LoginUaePassPage key={'LoginUaePassPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.UAE_PASS_OTP} element={<CompleteProfileMiddleWare><LoginUaePassPageOTP key={'LoginUaePassPageOTP'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.REGISTER} element={<CompleteProfileMiddleWare><RegisterPage key={'RegisterPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.HORSE_AUCTION} element={<CompleteProfileMiddleWare><HorseProfile key={'HorseProfile'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.BIDDING} element={<CompleteProfileMiddleWare><BiddingPage key={'BiddingPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.FULL_SCREEN_BIDDING} element={<CompleteProfileMiddleWare><LiveBiddingScreen key={'LiveBiddingScreen'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.HYBRID_BIDDING} element={<CompleteProfileMiddleWare><HybridBiddingPage toast={toast} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.PROFILE}
            element={
              <PrivateRoute>
                <OwnerProfile />
              </PrivateRoute>
            }
          />
          <Route path={RoutesName.HORSE_MARKET} element={<CompleteProfileMiddleWare><HorseMarket key={'HorseMarket'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SHOWS} element={<CompleteProfileMiddleWare><Shows key={'Shows'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SHOW_DETAILS} element={<CompleteProfileMiddleWare><ShowDetails key={'ShowDetails'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.FORGET_PASSWORD} element={<CompleteProfileMiddleWare><ForgetPasswordPage key={'ForgetPasswordPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SINGLE_SERVICE} element={<CompleteProfileMiddleWare><SingleServicePage key={'SingleServicePage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SINGLE_POST} element={<CompleteProfileMiddleWare><SinglePost key={'SinglePost'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ABOUT_US} element={<CompleteProfileMiddleWare><AboutUs key={'AboutUs'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.NEWS} element={<CompleteProfileMiddleWare><NewsPage key={'NewsPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.HORSE_SUPPLIES} element={<CompleteProfileMiddleWare><HorseSupplies key={'HorseSupplies'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SINGLE_SUPPLIER} element={<CompleteProfileMiddleWare><SingleSupplier key={'SingleSupplier'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.JUDGES_PAGE} element={<CompleteProfileMiddleWare><JudgesPage key={'JudgesPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.PRESIDENT_WORD} element={<CompleteProfileMiddleWare><PresidentWord key={'PresidentWord'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.LIBRARY_PAGE} element={<CompleteProfileMiddleWare><LibraryPage key={'LibraryPage'} /></CompleteProfileMiddleWare>} />

          <Route
            path={RoutesName.HORSE_TRANSPORT_COMPANIES}
            element={<CompleteProfileMiddleWare><HorseTransportCompanies key={'HorseTransportCompanies'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.SINGLE_TRANSPORT_COMPANY}
            element={<CompleteProfileMiddleWare><SingleTransportCompany key={'SingleTransportCompany'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.HORSE_HOSPITALS} element={<CompleteProfileMiddleWare><HorseHospitals key={'HorseHospitals'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SINGLE_HOSPITAL} element={<CompleteProfileMiddleWare><SingleHospital key={'SingleHospital'} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.EQUESTRIAN_CENTERS_CLUBS}
            element={<CompleteProfileMiddleWare><EquestrianCentersClubs key={'EquestrianCentersClubs'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.SINGLE_EQUESTRIAN_CENTERS_CLUBS}
            element={<CompleteProfileMiddleWare><SingleEquestrianCentersClubs key={'SingleEquestrianCentersClubs'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.CONTACT_US} element={<CompleteProfileMiddleWare><ContactUs key={'ContactUs'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SERVICES} element={<CompleteProfileMiddleWare><ServicesPage key={'ServicesPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ORG_CHART} element={<CompleteProfileMiddleWare><OrgChartPage key={'OrgChartPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.WAHO_CONFERENCE} element={<CompleteProfileMiddleWare><WahoConference key={'WahoConference'} /></CompleteProfileMiddleWare>} />
          <Route path="/m-wahoconference" element={<CompleteProfileMiddleWare><WahoConference key={'WahoConference'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SHOW_ENTRY_CARD} element={<CompleteProfileMiddleWare><ShowEntryCard key={'ShowEntryCard'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.CALENDAR} element={<CompleteProfileMiddleWare><CalendarPage key={'CalendarPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ADD_EARLY_YEARLING_HORSE} element={<CompleteProfileMiddleWare><AddFoalHorse key={'add foal Horse'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SHOW_ENTRY_DETAILS}
            element={
              <CompleteProfileMiddleWare>
                <PrivateRoute>
                  <ShowEntryDetails key={'ShowEntryDetails'} toast={toast} />
                </PrivateRoute>
              </CompleteProfileMiddleWare>
            } />
          <Route path={RoutesName.ADD_REGISTER_HORSE} element={<CompleteProfileMiddleWare><AddRegisterHorse key={'AddRegisterHorse'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SHOW_ENTRY_CONFLICT} element={<CompleteProfileMiddleWare><ShowEntryConflict key={'ShowEntryConflict'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.COURSES} element={<CompleteProfileMiddleWare><CoursesNewPage key={'CoursesNewPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.COURSE_DETAILS} element={<CompleteProfileMiddleWare><CoursesPage key={'courseDetails'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.COURSE_ENROLLMENT} element={<CompleteProfileMiddleWare><CourseEnrollment key={'courseEnrollment'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.COURSE_ENROLLMENT_DATE} element={<CourseEnrollmentDate key={'courseEnrollmentDate'} toast={toast} />} />
          <Route path={RoutesName.SPONSORS_PAGE} element={<CompleteProfileMiddleWare><SponsersPage key={'SponsersPage'} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SHOW_ENTRY_TOTAL_REGISTERED_HORSES}
            element={<CompleteProfileMiddleWare><ShowEntryTotalRegisteredHorses key={'ShowEntryTotalRegisteredHorses'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.SHOW_ENTRY_PARTICIPANTS_REQUEST}
            element={<CompleteProfileMiddleWare><ShowEntryParticipantsRequest key={'ShowEntryParticipantsRequest'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.SHOW_ENTRY_SUBMISSION_SUCCESSFUL}
            element={<CompleteProfileMiddleWare><ShowEntrySubmissionSuccessful key={'ShowEntrySubmissionSuccessful'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.GALLERY} element={<CompleteProfileMiddleWare><GalleryPage key={'GalleryPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ALBUM_DETAILS} element={<CompleteProfileMiddleWare><AlbumPage key={'AlbumPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.WAHO_TROPHY} element={<CompleteProfileMiddleWare><WahoTrophy key={'WahoTrophy'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.BOOK_TABLE} element={<CompleteProfileMiddleWare><BookTable key={'BookTable'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ADS_BOOK_TABLE} element={<CompleteProfileMiddleWare><BookTable isAds={true} /></CompleteProfileMiddleWare>} />
          {/* <Route path={RoutesName.OPEND_EVENTS} element={<OpendBooking key="events" />} />
          <Route
            path={RoutesName.OPEND_ADS}
            element={<OpendBooking isAds={true} key="ads" />}
          /> */}
          <Route path={RoutesName.OPEND_ADS} element={<CompleteProfileMiddleWare><OpendBooking key="events" /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.OPEND_EVENTS}
            element={<CompleteProfileMiddleWare><OpendBooking isAds={true} key="ads" /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.SHOWS_CATEGORIES} element={<CompleteProfileMiddleWare><ShowsCategories key={RoutesName.SHOWS_CATEGORIES} ShowsCategoriesID={ShowsCategoriesID} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} element={<CompleteProfileMiddleWare><ShowsCategories key={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} hasHTML={true} ShowsCategoriesID={NoneEcahoShowsCategoriesID} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.AUCTION_ENTRY_CARD} element={<CompleteProfileMiddleWare><AuctionEntryCard key={'AuctionEntryCard'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.EAHS_AWARD} element={<CompleteProfileMiddleWare><AwardPage key={'AwardPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.OPEN_APP_OR_STORE} element={<CompleteProfileMiddleWare><OpenApp key={'OpenApp'} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.AUCTION_ENTRY_TOTAL_REGISTERED_HORSES}
            element={<CompleteProfileMiddleWare><Auctionentrytotalregisteredhorses key={'Auctionentrytotalregisteredhorses'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.AUCTION_ENTRY_SUBMISSION_SUCCESSFUL}
            element={<CompleteProfileMiddleWare><AuctionEntrySubmissionSuccessful key={'AuctionEntrySubmissionSuccessful'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.BOOKING_SUCCESSFUL}
            element={<CompleteProfileMiddleWare><BookingSubmissionSuccessful key={'BookingSubmissionSuccessful'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_HORSE_OWNERSHIP_TRANSFER_SELLER}
            element={<CompleteProfileMiddleWare><RequestHorseOwnershipTransferSeller key={'RequestHorseOwnershipTransferSeller'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.SERVICES_REQUESTS_PAYMENT_SUCCESSFUL}
            element={<CompleteProfileMiddleWare><ServicesRequestsPaymentSuccessful key={'ServicesRequestsPaymentSuccessful'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.EDUCATIONAL_COURSES} element={<CompleteProfileMiddleWare><EducationalPage key={'EducationalPage'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.ADD_INTERNATIONAL_HORSE} element={<CompleteProfileMiddleWare><AddInternationalHorse key={'addInternationalHorse'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.SHOW_ENTRY_CHECKOUT_PAGE} element={<CompleteProfileMiddleWare><ShowEntryCheckoutPage key={'ShowEntryCheckoutPage'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SINGLE_TERMS_AND_CONDITIONS_SHOW_PAGE}
            element={<CompleteProfileMiddleWare><SingleTermsAndConditionsShowPage key={'SingleTermsAndConditionsShowPage'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.ADD_ORGANIZER_REQUEST}
            element={<CompleteProfileMiddleWare><AddOrganizerRequest key={'AddOrganizerRequest'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.SHOW_CATALOG} element={<CompleteProfileMiddleWare><ShowCatalog key={'ShowCatalog'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.NOT_FOUND_404} element={<CompleteProfileMiddleWare><ComingSoon key={'ComingSoon'} /></CompleteProfileMiddleWare>} />
          <Route path={RoutesName.NOT_AUTHORIZED_403} key={'not Auth'} element={<ComingSoon key={'not authrized'} text="web.notAuthrized" defaultText="Not Authrized" />} />
          <Route path={RoutesName.LIVE_EVENT} element={<CompleteProfileMiddleWare><LiveStream key={'LiveStream'} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.REQUEST_COVERING_CERTIFICATE}
            element={<CompleteProfileMiddleWare><RequestCoveringCertificate key={'RequestCoveringCertificate'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_EMBRYO_OOCYTE_TRANSFER_PERMIT}
            element={<CompleteProfileMiddleWare><RequestEmbryoOocyteTransferPermit key={'RequestEmbryoOocyteTransferPermit'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_EMBRYO_TRANSFER_RIGHT_PURCHASE_AGREEMENT}
            element={<CompleteProfileMiddleWare><RequestEmbryoTransferRightPurchaceAgreement key={'RequestEmbryoTransferRightPurchaceAgreement'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_REGISTERING_NEW_ARABIAN_HORSE_FOAL}
            element={<CompleteProfileMiddleWare><RequestRegisteringNewArabianHorseFoal key={'RequestRegisteringNewArabianHorseFoal'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_OWNED_HORSES_CERTIFICATE}
            element={<CompleteProfileMiddleWare><RequestForOwnedEAHSRegisteredHorsesCertificate key={'RequestForOwnedEAHSRegisteredHorsesCertificate'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_REGISTER_ARABIAN_HORSE_STUD}
            element={<CompleteProfileMiddleWare><RequestForRegistrationOfAnArabianHorseStud toast={toast} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_UPDATE_HORSE_DATA}
            element={<CompleteProfileMiddleWare><RequestToUpdateArabianHorseData key={'RequestToUpdateArabianHorseData'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_HORSE_DEATH_DECLARATION}
            element={<CompleteProfileMiddleWare><RequestToDeclarationOfArabianHorseDeath key={'RequestToDeclarationOfArabianHorseDeath'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.INACTIVE_HORSE_REGISTRATION_REQUEST}
            element={<CompleteProfileMiddleWare><InactiveHorseRegistrationRequest key={'InactiveHorseRegistrationRequest'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_RACING_NAME_IMPORTED_HORSE}
            element={<CompleteProfileMiddleWare><RequestToAddARacingNameForAnImportedArabianHorse key={'RequestToAddARacingNameForAnImportedArabianHorse'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_PASSPORT_DUPLICATE_DAMAGED}
            element={<CompleteProfileMiddleWare><ReqestForIssuingAnArabianHorsePassportDuplicateDamaged key={'ReqestForIssuingAnArabianHorsePassportDuplicateDamaged'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.IMPORT_HORSE_FROZEN_SEMEN}
            element={<CompleteProfileMiddleWare><ImportHorseFrozenSemen key={'ImportHorseFrozenSemen'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.IMPORT_HORSE}
            element={<CompleteProfileMiddleWare><ImportHorse key={'ImportHorse'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.GENETIC_DISORDER_TESTING}
            element={<CompleteProfileMiddleWare><GeneticDisorderTesting key={'GeneticDisorderTesting'} /></CompleteProfileMiddleWare>}
          />
          <Route
            path={RoutesName.REQUEST_SEMEN_CERTIFICATE}
            element={<CompleteProfileMiddleWare><RequestSemenCertificate key={'RequestSemenCertificate'} /></CompleteProfileMiddleWare>}
          />
          <Route path={RoutesName.EXPORT_HORSE} element={<ExportHorse key={'ExportHorse'} toast={toast} />} />

          <Route
            path={RoutesName.CANCEL_EXPORT_HORSE}
            element={<CompleteProfileMiddleWare><CancelExportHorse key={'CancelExportHorse'} /></CompleteProfileMiddleWare>}
          />

          <Route
            path={RoutesName.EXPORT_HORSE_SEMEN}
            element={<CompleteProfileMiddleWare><ExportHorseSemen key={'ExportHorseSemen'} /></CompleteProfileMiddleWare>}
          />

          <Route
            path={RoutesName.PRESS_COVERAGE_REQUEST}
            element={<CompleteProfileMiddleWare><PressCoverageRequest key={'PressCoverageRequest'} /></CompleteProfileMiddleWare>}
          />
          {/* <Route
            path="/m-opend-events"
            element={<OpendBooking isMobileWebView={true} isAds={true} />}
          />
          <Route
            path="/m-opend-ads"
            element={<OpendBooking  isMobileWebView={true} />}
          /> */}
          <Route
            path="/m-opend-ads"
            element={<OpendBooking isMobileWebView={true} isAds={true} />}
          />
          <Route
            path="/m-opend-events"
            element={<OpendBooking isMobileWebView={true} />}
          />
          <Route path="/m-book-table" element={<BookTable />} />
          <Route
            path="/m-ads-book-table"
            element={<BookTable isAds={true} />}
          />
          <Route
            path={RoutesName.SHOW_PARTICIPATE}
            element={
              <CompleteProfileMiddleWare>
                <PrivateRoute>
                  <ShowParticipatePage key={'participation Page'} toast={toast} />
                </PrivateRoute>
              </CompleteProfileMiddleWare>
            } />
          <Route
            path={RoutesName.AUCTION_PARTICIPATE}
            element={
              <CompleteProfileMiddleWare>
                <PrivateRoute>
                  <AucitonEntryParticipate key={'participation Page'} toast={toast} />
                </PrivateRoute>
              </CompleteProfileMiddleWare>
            }
          />
          <Route
            path={RoutesName.AUCTION_ENTRY_CHECKOUT_PAGE}
            element={<CompleteProfileMiddleWare><AuctionEntryCheckoutPage key={'AuctionEntryCheckoutPage Page'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.CHULIBPAGE}
            element={<CompleteProfileMiddleWare><ChulibPage key={'CHULIB Page'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SEMENMARKET}
            element={<CompleteProfileMiddleWare><SemenMarketListPage key={'SEMENMARKET'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.OWNERSSERVICEFORM}
            element={<CompleteProfileMiddleWare><OwnerServicesForm key={'OWNERSSERVICEFORM'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SEMENDETAILS}
            element={<CompleteProfileMiddleWare><SemenDetails key={'SEMENDETAILS'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={RoutesName.SEMENCHECKOUT}
            element={<CompleteProfileMiddleWare><SemenCheckout key={'SEMENCHECKOUT'} toast={toast} /></CompleteProfileMiddleWare>} />
          <Route
            path={'/fontsCompetitionRegistration'}
            element={<CompleteProfileMiddleWare><FontCompetitionPage key={'OWNERSSERVICEFORM'} /></CompleteProfileMiddleWare>} />
          <Route
            path={'/digitalCatalog'}
            element={<CompleteProfileMiddleWare><DigitalCatalog key={'digitalCatalog'} /></CompleteProfileMiddleWare>} />

        </Routes>
      </Layout>

    </Router>
  );
}

export default App;
